import React from "react";
import { Box, Typography, Container, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GradientButton from "./GradiantButton";

const NotFound = () => {
  const navigate = useNavigate();
  const brand = useSelector((s) => s.themeValue?.colors) || {};
  const start = brand.primary_gradient_start_color || "#FF2D95";
  const end = brand.primary_gradient_end_color || "#7B1FA2";

  return (
    <Box
      sx={{
        bgcolor: brand.screen_background || "#FBF8FC",
        py: { xs: 8, md: 12 },
        minHeight: "60vh",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Container maxWidth="sm">
        <Stack alignItems="center" spacing={2} textAlign="center">
          <Typography
            sx={{
              fontSize: { xs: "4.5rem", md: "6rem" },
              fontWeight: 800,
              lineHeight: 1,
              background: `linear-gradient(90deg, ${start}, ${end})`,
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            404
          </Typography>

          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Box sx={{ width: 36, height: 2, bgcolor: end, borderRadius: 1 }} />
            <Typography
              sx={{
                fontSize: 13,
                fontWeight: 700,
                letterSpacing: 2,
                textTransform: "uppercase",
                color: end,
              }}
            >
              Not Found
            </Typography>
            <Box sx={{ width: 36, height: 2, bgcolor: end, borderRadius: 1 }} />
          </Stack>

          <Typography
            variant="h5"
            fontWeight={800}
            sx={{ color: "#1A1A2E", fontSize: { xs: "1.4rem", md: "1.75rem" } }}
          >
            Page not found
          </Typography>

          <Typography
            variant="body1"
            sx={{ color: "text.secondary", lineHeight: 1.7, maxWidth: 420 }}
          >
            The page you are looking for does not exist or has been moved.
            Check the URL, or return to the homepage to continue browsing
            properties.
          </Typography>

          <Box sx={{ pt: 1, width: "100%", display: "flex", justifyContent: "center" }}>
            <GradientButton
              text="Go to Home"
              width="220px"
              onClick={() => navigate("/")}
            />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default NotFound;
